<template>
  <div class="bigData-container-r fix-box-between">
    <rankingOfAssets class='rankingOfAssets'/>
    <rentalRateAnalysis class='rankingOfAssets'/>
    <rentArrears class='rankingOfAssets'/>
    <contractExpirationWarning class='rankingOfAssets'/>
    <premiumRateDistribution class='rankingOfAssets'/>
    <assetUseDistribution class='rankingOfAssets'/>
    <dailyRentDistribution class='dailyRentDistribution'/>


  </div>
</template>

<script>
  import rankingOfAssets from './rankingOfAssets'
  import rentalRateAnalysis from './rentalRateAnalysis'
  import rentArrears from './rentArrears'
  import contractExpirationWarning from './contractExpirationWarning'
  import premiumRateDistribution from './premiumRateDistribution'
  import assetUseDistribution from './assetUseDistribution'
  import dailyRentDistribution from './dailyRentDistribution'
  export default {
    name: "dataRight",
    components: {
      rankingOfAssets,
      rentalRateAnalysis,
      rentArrears,
      contractExpirationWarning,
      premiumRateDistribution,
      assetUseDistribution,
      dailyRentDistribution,
    },
    data() {
      return {}
    },
    methods: {},
    created() {

    },
  }
</script>

<style scoped lang="scss">
  .bigData-container-r {
    width: 32.38%;
    float: right;
    flex-wrap: wrap;
    margin-top: 0;
  }
  .rankingOfAssets{
    width: 49%;
    margin-bottom: 12px;
    box-sizing: border-box;
    height: 265px!important;
  }
  .dailyRentDistribution{
    width: 100%;
    margin-bottom: 12px;
    height: 216px!important;
  }
  @media screen and (max-width: 1903px) {
    .bigData-container-r {
      width: 100%;
      float: none;
      margin-top: 12px;
    }
    .rankingOfAssets{
      width: 24.3%;
    }
    .dailyRentDistribution{
      width: 49.5%;
      height: 266px!important;
    }
  }
</style>
